
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matches",
      function () {
        return require("private-next-pages/matches/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matches"])
      });
    }
  